<ion-input
  [value]="value"
  type="text"
  pattern="^\d{4}-\d{1,2}-\d{1,2}$"
  (ionInput)="onInputChange($event)"
  (ionBlur)="onInputBlur()"
  (keydown)="onkeydown ? onkeydown($event) : null"
  labelPlacement="stacked"
  [label]="labelText"
  inputmode="numeric"
  [attr.required]="required ? true : null"
  [class.invalid]="isInvalid"
  [attr.maxlength]="10"
  [attr.minlength]="8"
  [attr.inputmode]="inputmode ? inputmode : null"
  [attr.autocomplete]="autocomplete ? autocomplete : null"
  [placeholder]="actualPlaceholder"
  color="dark"
  fill="outline"
>
  <ion-icon *ngIf="iconStartSrc" slot="start" aria-hidden="true" [src]="iconStartSrc"></ion-icon>
  <ion-icon *ngIf="iconEndSrc" slot="end" aria-hidden="true" [src]="iconEndSrc"></ion-icon>
  <ng-content></ng-content>
  
</ion-input>
